import '../index.css'

const ApiDoc = (props) => {
  return <iframe src={`${window.location.origin}/${process.env.REACT_APP_APIDOCS_FILE}`} style={{ width: '100%', height: 'calc(100vh - 4px)', border: 0, padding: 0, margin: 0, overflow: 'hidden' }} />
}

export default ApiDoc;